import { graphql } from "relay-runtime"

export const de_PointOfCareSpecialtyQuery = graphql`
  query useDePointOfCareSpecialtyQuery($searchText: String!) {
    dePointOfCareSpecialties: de_pointOfCareSpecialties(
      first: 50
      order: [{ word: ASC }]
      where: {
        or: [
          { word: { contains: $searchText } }
          { synonym: { contains: $searchText } }
          { specialtyTranslations: { some: { name: { contains: $searchText } } } }
        ]
      }
    ) {
      nodes {
        id
        word
        synonym
        specialtyTranslations {
          language
          name
        }
        betterDocKey
      }
    }
  }
`
